define.alias("ember-math-helpers/helpers/sin", "calendar/helpers/sin");